import Vue from 'vue';
import axios from 'axios';
import Constants from '@/plugins/constants';
const apiClient = axios.create({
  baseURL: Constants.MAINURL,
  withCredentials: true,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});
var options = {
  persist: true,
};
Vue.use(options);
apiClient.interceptors.request.use(
  function (config) {
    config.headers['Content-Type'] = 'application/json';
    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

const state = {
  error400: false,
  error: '',
  successFlag: false,
  token: '',
  hospitalAdmissionsReport: [],
  allHospitalAdmissionsActive: [],
  totalPages: 0,
  totalRecords: 0,
  errorStatus: null,
};
const getters = {
  getApiLoad_41: (state) => {
    return state.successFlag;
  },
};
const mutations = {
  set_error400(state, error) {
    state.error400 = error;
  },
  SET_Status(state, status) {
    state.successFlag = status;
  },
  SET_Error(state, error) {
    state.error = error;
  },
  SET_errorStatus(state, error) {
    state.errorStatus = error;
  },
  SET_AllHospitalAdmissionsActive(state, data) {
    state.allHospitalAdmissionsActive = data;
  },
  SET_HospitalAdmissionsReport(state, hospitalAdmissions) {
    state.hospitalAdmissionsReport = hospitalAdmissions.items;
    state.totalPages = hospitalAdmissions.totalPages;
    state.totalRecords = hospitalAdmissions?.totalRecords ?? 0;
  },
};
const actions = {
  errorHospitalAdmission({ commit }, temperror) {
    var error = temperror;
    if (error) {
      if (error.response) {
        if (error.response.status) {
          if (error.response.status == 401) {
            commit('SET_errorStatus', true);
            commit('set_error400', false);
          } else if (error.response.status == 400) {
            commit('SET_errorStatus', false);
            commit('set_error400', true);
          } else {
            commit('SET_errorStatus', false);
            commit('set_error400', false);
          }
        }
        if (error.response.data) {
          commit('SET_Error', error.response.data.message);
        } else {
          commit('SET_Error', 'عدم ارتباط با سرور');
        }
      } else {
        commit('SET_errorStatus', false);
        commit('set_error400', false);
        commit('SET_Error', 'خطا در برقراری ارتباط با سرور');
      }
      commit('SET_Status', false);
    } else {
      commit('SET_Error', 'خطا امنیتی');
    }
  },
  getAllHospitalAdmissionsActive({ commit, dispatch, rootState }) {
    return apiClient
      .get('/HospitalAdmissions/AllActive', {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_AllHospitalAdmissionsActive', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorHospitalAdmission', error);
      });
  },
  getHospitalAdmissionsWithPaginationReport(
    { commit, dispatch, rootState },
    { pageNumber, pageSize, hospitalId, phoneCode, fullName, fromDate, toDate },
  ) {
    var url = '/HospitalAdmissions/Report?pageNumber=' + pageNumber + '&pageSize=' + pageSize;
    if (hospitalId) {
      url += '&HospitalId=' + hospitalId;
    }
    if (phoneCode) {
      url += '&PhoneCode=' + phoneCode;
    }
    if (fullName) {
      url += '&FullName=' + fullName;
    }
    if (fromDate) {
      url += '&FromDate=' + fromDate;
    }
    if (toDate) {
      url += '&ToDate=' + toDate;
    }
    return apiClient
      .get(url, { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } })
      .then((response) => {
        commit('SET_HospitalAdmissionsReport', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorHospitalAdmission', error);
      });
  },
  addHospitalAdmission({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/HospitalAdmissions/Accept', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorHospitalAdmission', error);
      });
  },
};
export default {
  mutations,
  getters,
  state,
  actions,
};
